import { CardInputWithType, ECardType } from '__generated__/globalTypes';
import { FFullMoment_cards } from 'graphql/fragment/__generated__/FFullMoment';
import { ICard, ICardInputWithTypeAndId } from 'libs/types/card/cardTypes';

export function createCardBody(type: ECardType): ICard {
    if (type === ECardType.TEXT) {
        return {
            info: {
                title: '',
                description: ''
            }
        };
    } else if (type === ECardType.IMAGE) {
        return {
            images: []
        };
    } else if (type === ECardType.VIDEO) {
        return {
            video: {
                videoId: ''
            }
        };
    } else if (type === ECardType.LINK) {
        return {
            links: []
        };
    } else if (type === ECardType.MAP) {
        return {
            location: {
                center: {
                    lat: null,
                    lng: null
                },
                markers: [],
                zoom: null
            }
        };
    } else if (type === ECardType.GIF) {
        return {
            gif: {
                gifUrl: ''
            }
        };
    } else if (type === ECardType.TWITTER) {
        return {
            twitter: {
                postId: ''
            }
        };
    } else if (type === ECardType.INSTAGRAM) {
        return {
            instagram: {
                postId: ''
            }
        };
    } else if (type === ECardType.FACEBOOK) {
        return {
            facebook: {
                postId: ''
            }
        };
    } else if (type === ECardType.AUDIO) {
        return {
            audio: {
                fileUrl: ''
            }
        };
    } else if (type === ECardType.LINKEDSTORIES) {
        return {
            info: {
                title: ''
            },
            linkedStories: {
                storyIds: []
            }
        };
    } else return {};
}

export function mapCardInputToFullCard(card: ICardInputWithTypeAndId): FFullMoment_cards {
    if (card.type === ECardType.TEXT) {
        return {
            cardId: card.cardId,
            __typename: 'TextCard',
            info: {
                title: card.info?.title,
                description: card.info?.description,
                __typename: 'CardInfo'
            },
            type: card.type
        };
    } else if (card.type === ECardType.IMAGE) {
        return {
            cardId: card.cardId,
            images: card.images.map((e) => ({
                imageUrl: e.imageUrl,
                fullImageUrl: e.fullImageUrl,
                description: e.description,
                __typename: 'Image'
            })),
            __typename: 'ImageCard',
            containImage: false,
            type: card.type
        };
    } else if (card.type === ECardType.VIDEO) {
        return {
            __typename: 'VideoCard',
            cardId: card.cardId,
            video: {
                videoId: card.video?.videoId,
                __typename: 'Video'
            },
            type: card.type
        };
    } else if (card.type === ECardType.LINK) {
        return {
            cardId: card.cardId,
            links: card.links?.map((link) => ({
                title: link.title,
                url: link.url,
                __typename: 'Link'
            })),
            type: card.type,
            __typename: 'LinkCard'
        };
    } else if (card.type === ECardType.MAP) {
        return {
            cardId: card.cardId,
            location: {
                title: card.location?.title,
                center: {
                    lat: card.location?.center?.lat,
                    lng: card.location?.center?.lng,
                    __typename: 'Coordinates'
                },
                markers: card.location?.markers?.map((marker) => ({
                    lat: marker.lat,
                    lng: marker.lng,
                    addressLabel: marker.addressLabel,
                    __typename: 'LocationMarker'
                })),
                zoom: card.location?.zoom,
                __typename: 'Location'
            },
            type: card.type,
            __typename: 'MapCard'
        };
    } else if (card.type === ECardType.GIF) {
        return {
            __typename: 'GifCard',
            cardId: card.cardId,
            gif: {
                gifUrl: card.gif?.gifUrl,
                __typename: 'Gif'
            },
            type: card.type
        };
    } else if (card.type === ECardType.TWITTER) {
        return {
            __typename: 'TwitterCard',
            cardId: card.cardId,
            twitter: {
                postId: card.twitter?.postId,
                __typename: 'Twitter'
            },
            type: card.type
        };
    } else if (card.type === ECardType.INSTAGRAM) {
        return {
            __typename: 'InstagramCard',
            cardId: card.cardId,
            instagram: {
                postId: card.instagram?.postId,
                __typename: 'Instagram'
            },
            type: card.type
        };
    } else if (card.type === ECardType.FACEBOOK) {
        return {
            __typename: 'FacebookCard',
            cardId: card.cardId,
            facebook: {
                postId: card.facebook?.postId,
                __typename: 'Facebook'
            },
            type: card.type
        };
    } else if (card.type === ECardType.LINKEDSTORIES) {
        return {
            __typename: 'LinkedStoriesCard',
            cardId: card.cardId,
            info: {
                title: card?.info?.title,
                __typename: 'CardInfo'
            },
            linkedStories: {
                storyIds: card?.linkedStories?.storyIds,
                __typename: 'LinkedStories'
            },
            type: card.type
        };
    }
}

export function mapFullCardToCardInput(card: FFullMoment_cards): CardInputWithType {
    if (card.__typename === 'TextCard') {
        return {
            info: {
                title: card?.info?.title,
                description: card?.info?.description
            },
            type: ECardType.TEXT
        };
    } else if (card.__typename === 'ImageCard') {
        return {
            images: card.images.map((e) => ({
                imageUrl: e.imageUrl,
                fullImageUrl: e.fullImageUrl
            })),
            type: ECardType.IMAGE
        };
    } else if (card.__typename === 'VideoCard') {
        return {
            video: {
                videoId: card.video?.videoId
            },
            type: ECardType.VIDEO
        };
    } else if (card.__typename === 'LinkCard') {
        return {
            links: card.links?.map((link) => ({ title: link.title, url: link.url })),
            type: ECardType.LINK
        };
    } else if (card.__typename === 'MapCard') {
        return {
            location: {
                title: card.location?.title,
                center: {
                    lat: card.location?.center?.lat,
                    lng: card.location?.center?.lng
                },
                markers: card.location?.markers?.map((marker) => ({
                    lat: marker.lat,
                    lng: marker.lng,
                    addressLabel: marker.addressLabel
                })),
                zoom: card.location?.zoom
            },
            type: ECardType.MAP
        };
    } else if (card.__typename === 'GifCard') {
        return {
            gif: {
                gifUrl: card.gif?.gifUrl
            },
            type: ECardType.GIF
        };
    } else if (card.__typename === 'TwitterCard') {
        return {
            twitter: {
                postId: card.twitter?.postId
            },
            type: ECardType.TWITTER
        };
    } else if (card.__typename === 'InstagramCard') {
        return {
            instagram: {
                postId: card.instagram?.postId
            },
            type: ECardType.INSTAGRAM
        };
    } else if (card.__typename === 'FacebookCard') {
        return {
            facebook: {
                postId: card.facebook?.postId
            },
            type: ECardType.FACEBOOK
        };
    } else if (card.__typename === 'AudioCard') {
        return {
            audio: {
                fileUrl: card.audio?.fileUrl
            },
            type: ECardType.AUDIO
        };
    } else if (card.__typename === 'LinkedStoriesCard') {
        return {
            info: {
                title: card.info?.title
            },
            linkedStories: {
                storyIds: card.linkedStories?.storyIds ?? []
            },
            type: ECardType.LINKEDSTORIES
        };
    } else return null;
}
